import React from 'react';
import classNames from 'classnames';

import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';

import styles from './tinyIdeaCardStyles.scss';

export enum SIZES {
  SMALLER = 'smaller',
  DEFAULT = 'default'
}

export interface TinyIdeaCardProps {
  primarySymbols: string[];
  totalReturn: number;
  ideaUrl: string;
  isPairTrade?: boolean;
  isBlank?: boolean;
  size?: SIZES;
  dataTag?: string;
}

const TinyIdeaCard: React.FunctionComponent<TinyIdeaCardProps> = ({
  primarySymbols,
  totalReturn,
  ideaUrl,
  isPairTrade = false,
  isBlank = false,
  size = SIZES.DEFAULT,
  dataTag = null
}): React.ReactElement => {
  if (isBlank) {
    return <div className={styles.blankTinyIdeaCard} />;
  }

  const isRedacted = primarySymbols[0] === 'Redacted';
  const Element = isRedacted ? 'span' : 'a';

  return (
    <div className={styles.root}>
      <Element data-heap={dataTag} href={ideaUrl}>
        <div
          className={classNames(styles.symbol, {
            [styles.smallSymbol]: size === SIZES.SMALLER
          })}
        >
          {isRedacted ? (
            <RedactedDataPoint Wrapper="div" overlayLeft="0px" blurLeft="10px" />
          ) : (
            <>{primarySymbols[0]}</>
          )}
        </div>
        {isPairTrade ? <div className={styles.symbol}>{primarySymbols[1]}</div> : null}
        <div
          className={classNames({
            [styles.smallReturns]: size === SIZES.SMALLER
          })}
        >
          <ReturnValue value={totalReturn} />
        </div>
      </Element>
    </div>
  );
};

export default TinyIdeaCard;
